import React, { useState } from "react";
import { DataContext } from "../../helper/HelperOne";
import NavBar from "../nav_bar/Navbar";
import SalesmenList from "./Salesmenlist";

function Salesmen() {
  const [searchUi, setSearchUi] = useState(false);
  const [searchData, setSearchData] = useState(null);

  return (
    <DataContext.Provider
      value={{ searchUi, setSearchUi, searchData, setSearchData }}
    >
      <NavBar childrenPage={<SalesmenList />} menuId={9} />
    </DataContext.Provider>
  );
}

export default Salesmen;
